<template>
  <div class="modal-content">
    <div class="form-group">
      <label>{{ props.label }}</label>
      <DxNumberBox v-bind="props.dxInputProps" v-model="numberValue" ref="dxEditorRef">
        <DxValidator v-if="props.required" ref="dxValidatorRef">
          <DxRequiredRule :message="$t('shared.input_box.campo_requerido')" />
        </DxValidator>
      </DxNumberBox>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getCurrentInstance, onMounted, ref } from "vue";
import { modalDefinedEmits, type ToolbarReference, useModalBuilder } from "@helpers/modal-building-helper";
import { messageBoxResult } from "@components/dialogs/message-box";
import { DxButton } from "devextreme-vue/button";
import DxNumberBox from "devextreme-vue/number-box";
import type { IInputNumberBoxProps } from "./models/IInputNumberBoxProps";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";

const props = withDefaults(defineProps<IInputNumberBoxProps>(), { required: false });
defineEmits([...modalDefinedEmits]);

const numberValue = ref<number | null>(props.dxInputProps?.value ?? null);
const dxEditorRef = ref<DxNumberBox>();
const dxValidatorRef = ref<DxValidator>();

onMounted(() => {
  const modal = useModalBuilder();
  modal.setContext(getCurrentInstance()!);

  configureButtons(modal);
});

const configureButtons = (modal: ReturnType<typeof useModalBuilder>) => {
  let okButton: ToolbarReference<DxButton>;
  let cancelButton: ToolbarReference<DxButton>;

  ({ okButton, cancelButton } = modal.standardButtons.addOkCancel());

  okButton.update((w) => (w.onClick = () => {
    if (!props.required) {
      modal.close({ result: messageBoxResult.ok, value: numberValue.value });
      return;
    }
    const validationResult = dxValidatorRef.value!.instance!.validate();
    if (validationResult.isValid) {
      modal.close({ result: messageBoxResult.ok, value: numberValue.value });
    } else {
      dxValidatorRef.value!.instance!.focus();
    }
  }));

  cancelButton.update((w) => (w.onClick = () => modal.close({ result: messageBoxResult.cancel })));
};
</script>

<style scoped lang="scss"></style>
